import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import { COLOR_PRIMARY_BLACK } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { COUNTRY_SELECTOR_CLASSES } from "./constants";

export const CountrySelectorContainer = styled(Button)(({ theme }) => {
  const { BREAKPOINT_WIDE_DESKTOP } = getFormatMedia(theme);

  return {
    border: `1px solid rgba(0, 0, 0, 0.23)`,
    height: "48px",
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1.7),
    color: COLOR_PRIMARY_BLACK,
    cursor: "pointer",
    width: "100%",
    [BREAKPOINT_WIDE_DESKTOP]: {
      maxWidth: "240px",
    },
    "&:hover": {
      borderColor: COLOR_PRIMARY_BLACK,
    },
    [`& .${COUNTRY_SELECTOR_CLASSES.icon}`]: {
      marginRight: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      "& img": {
        width: "22px",
        height: "16px",
      },
    },
    [`& .${COUNTRY_SELECTOR_CLASSES.currentCountryLabel}`]: {
      whiteSpace: "nowrap",
      flex: 1,
    },
    [`& .${COUNTRY_SELECTOR_CLASSES.downIcon}`]: {
      pointerEvents: "none",
      marginTop: "5px",
    },
    [`& .${COUNTRY_SELECTOR_CLASSES.item}`]: {
      display: "flex",
      alignItems: "center",
    },
    [`& .${COUNTRY_SELECTOR_CLASSES.countryLabel}`]: {
      display: "none",
    },
  };
});
